export const schoolList = [
  '21st Century Cyber Charter School',
  'Aalto University',
  'Aarhus University',
  'Abbey Park High School',
  'Abbey Park Middle School',
  'Abertay University',
  'ABES Engineering College',
  'Abington Senior High School',
  'Abraham Lincoln High School',
  'Abraham Lincoln High School - Philadelphia',
  'Academy at Palumbo',
  'Academy of Technology',
  'Acardia High School, Arizona',
  'Acharya Institute of Technology',
  'Achievement House Charter School - Online',
  'ACT Academy Cyber Charter School',
  'Acton-Boxborough Regional High School',
  'Adelphi University',
  'Adlai E. Stevenson High School',
  'Advanced Math and Science Academy Charter School',
  'AGH University of Science and Technology',
  'Agnes Scott College',
  'Agora Cyber Charter School',
  'Alameda High School',
  'Albany Medical College',
  'Albany State University (GA)',
  'Albright College',
  'Alfa College',
  'Allen High School',
  'Ambala College of Engineering and Applied Research',
  'American Heritage School',
  'American High School',
  'American River College, California',
  'American University in Dubai',
  'American University, Washington, D.C.',
  'Amherst College',
  'Amity University',
  'Amrita School of Engineering',
  'Ancaster High School',
  'Anchor Bay High School',
  'Andover Central High School',
  'Anna University',
  'Appalachian State University',
  'Arcadia High School, California',
  'Arcadia University',
  'Arizona State University',
  'Art Institute of Philadelphia',
  'ASPIRA Bilingual Cyber Charter School',
  'Aston University',
  'Atlanta Metropolitan State College',
  'Atlantic Cape Community College',
  'Auburn University',
  'Austin Community College District',
  'Aviation Career & Technical Education High School',
  'Avon High School',
  'Babaria Institute of Technology',
  'Babson College',
  'Ball State University',
  'Bard College',
  'Barnard College',
  'Barton College',
  'Baruch College, CUNY',
  'Baton Rouge Community College',
  'Battlefield High School',
  'Bauman Moscow State Technical University',
  'Bayside High School',
  'Bayview Secondary School',
  'Beihang University',
  'Bellevue College, Washington',
  'Benedictine College',
  'Benha University',
  'Benjamin Franklin High School - Baltimore',
  'Benjamin Franklin High School - Philadelphia',
  'Bentley University',
  'Berea College',
  'Bergen Catholic High School',
  'Bergen Community College',
  'Bergen County Academies',
  'Bergen County Technical High School - Teterboro',
  'Berkshire Community College',
  'Bharathiar University',
  'Bilkent University',
  'Binghamton University',
  'Birkbeck, University of London',
  'Birla Institute of technology and Science, Pilani',
  'Birmingham City University',
  'Blinn College',
  'Bloomfield Hills High School',
  'Bloomsburg University of Pennsylvania',
  'Blue Mountain Academy',
  'BlueCrest University College',
  'Bluevale Collegiate Institute',
  'BMIIT, Uka Tarsadia University, Bardoli, Surat',
  'Boca Raton Community High School',
  'Boise State University',
  'Borough of Manhattan Community College, CUNY',
  'Boston College',
  'Boston Latin School',
  'Boston University',
  'Boston University Metropolitan College',
  'Bourne Grammar School',
  'Bournemouth University',
  'Bowdoin College',
  'Bowie State University',
  'Boys Latin of Philadelphia Charter School',
  'Brampton Centennial Secondary School',
  'Brandeis University',
  'Brentsville High School',
  'Briar Cliff University',
  'Bridgewater State University',
  'Brigham Young University',
  'British Columbia Institute of Technology',
  'Brno University of Technology',
  'Brock University',
  'Bronx Community College, CUNY',
  'Brookdale Community College',
  'Brooklyn College, CUNY',
  'Brooklyn Technical High School',
  'Brookwood High School',
  'Brown University',
  'Bryn Athyn College',
  'Bryn Mawr College',
  'Bucknell University',
  'Bucks County Community College',
  'Business Academy Aarhus',
  'C. D. Hylton High School',
  'Cabrini University',
  'Cadbury Sixth Form College',
  'Cairn University',
  'Caldwell University',
  'California High School',
  'California Institute of Technology',
  'California Polytechnic State University, San Luis Obispo',
  'California State Polytechnic University, Pomona',
  'California State University, Bakersfield',
  'California State University, Channel Islands',
  'California State University, Chico',
  'California State University, Dominguez Hills',
  'California State University, East Bay',
  'California State University, Fresno',
  'California State University, Fullerton',
  'California State University, Humboldt',
  'California State University, Long Beach',
  'California State University, Los Angeles',
  'California State University, Maritime',
  'California State University, Monterey Bay',
  'California State University, Northridge',
  'California State University, Sacramento',
  'California State University, San Bernardino',
  'California State University, San Diego',
  'California State University, San Francisco',
  'California State University, San Jose',
  'California State University, San Luis Obispo',
  'California State University, San Marcos',
  'California State University, Sonoma',
  'California State University, Stanislaus',
  'California University of Pennsylvania',
  'Calvin College',
  'Camden County College',
  'Cameron Heights Collegiate Institute',
  'Canada (Cañada) College',
  'Canyon Crest Academy',
  'CAPA - Philadelphia High School for Creative and Performing Arts',
  'Cardiff Metropolitan University',
  'Carleton College',
  'Carleton University',
  'Carnegie Mellon University',
  'Carteret High School',
  'Carthage College',
  'Cascadia College',
  'Case Western Reserve University',
  'Cathedral High School, Los Angeles',
  'Catholic University of America',
  'Cedar Creek High School',
  'Cedar Ridge High School',
  'Cedarville University',
  'Cégep André-Laurendeau',
  'Cégep de Saint-Laurent',
  'Cégep du Vieux Montréal',
  'Cégep Marie-Victorin',
  'Centennial Collegiate Vocational Institute',
  'Centennial High School',
  'Central Connecticut State University',
  'Central High School - Philadelphia',
  'Central PA Digital Learning Foundation Charter School',
  'Central Peel Secondary School',
  'Central Texas College',
  'Centro de Enseñanza Técnica y Superior (CETYS), Campus Ensenada',
  'Centro de Enseñanza Técnica y Superior (CETYS), Campus Mexicali',
  'Cerritos College',
  'Chalmers University of Technology',
  'Champlain College',
  'Channabasaveshwara Institute of Technology',
  'Chaparral Star Academy',
  'Chapel Hill High School',
  'Charter High School for Architecture and Design - Philadelphia',
  'Chattahoochee Technical College',
  'Cherokee High School',
  'Cherry Hill High School East',
  'Cherry Hill High School West',
  'Chestnut Hill College',
  'Cheyney University',
  'Chinguacousy Secondary School',
  'Cincinnati State Technical and Community College',
  'Citrus College',
  'City College of San Francisco',
  'City Neighbors High School',
  'City University London',
  'Claremont McKenna College',
  'Clarion University of Pennsylvania',
  'Clark Atlanta University',
  'Clark University',
  'Clarksburg High School',
  'Clarkson University',
  'Clayton State University',
  'Clemson University',
  'Cleveland State University',
  'CODE University of Applied Sciences Berlin',
  'Coe College',
  'Colegio Simón Bolívar',
  'Colgate University',
  'Collège Ahuntsic',
  'Collège André-Grasset',
  'Collège de Bois-de-Boulogne',
  'Collège de Maisonneuve',
  'Collège de Montréal',
  'Collège de Rosemont',
  'Collège Français',
  'Collège Jean-de-Brébeuf',
  'Collège Jean-Eudes',
  'Collège Lionel-Groulx',
  'College of Charleston',
  'College of DuPage',
  'College of Engineering, Pune',
  'College of Staten Island, CUNY',
  'College of Westchester',
  'Collège Regina Assumpta',
  'Colleyville Heritage High School',
  'Collins Hill High School',
  'Colorado School of Mines',
  'Columbia Secondary School',
  'Columbia University',
  'Columbus College of Art and Design',
  'Columbus State Community College',
  'Comenius University',
  'Commonwealth Charter Academy Charter School',
  'Community Academy of Philadelphia Charter School',
  'Community College of Allegheny County',
  'Community College of Baltimore County',
  'Community College of Philadelphia',
  'Community College of Rhode Island',
  'COMSATS Institute of Information Technology',
  'Concord Academy',
  'Concordia University',
  'Conestoga College',
  'Conestoga High School',
  'Connecticut College',
  'Conroe ISD Academy of Science and Technology, Texas',
  'Constitution High School - Philadelphia',
  'Cooper Union',
  'Coral Glades High School',
  'Cornell College',
  'Cornell University',
  'Council Rock High School North',
  'Council Rock High School South',
  'County College of Morris',
  'Covenant University',
  'Coventry University',
  'Cranbrook Schools',
  'Cranfield University',
  'Creekview High School',
  'Cumberland County College',
  'Cupertino High School',
  'Dalhousie University',
  'Dartmouth College',
  'Davidson College',
  'Dawson College',
  'De Anza College',
  'Deerfield High School',
  'Del Norte High School',
  'Delaware County Community College - Downingtown',
  'Delaware County Community College - Exton',
  'Delaware County Community College - Main Campus (Marple)',
  'Delaware County Community College - Phoenixville',
  'Delaware County Community College - Sharon Hill',
  'Delaware County Community College - Upper Darby',
  'Delaware County Community College - West Grove',
  'Delaware State University',
  'Delaware Technical Community College',
  'Delaware Valley Academy of Medical and Dental Assistants',
  'Delaware Valley University',
  'Delft University of Technology',
  'Delhi Technological University',
  'Denison University',
  'DePaul University',
  'DePauw University',
  'Des Moines Area Community College',
  'DeSales University',
  'Devry University - Philadelphia Center City',
  'Dharmsinh Desai University',
  'Diablo Valley College',
  'Dickinson College',
  'Digital Harbor High School',
  'Dougherty Valley High School',
  'Dr. B. R. Ambedkar National Institute of Technology Jalandhar',
  'Drake University',
  'Drew University',
  'Drexel University',
  'Dublin High School',
  'Dublin Jerome High School',
  'Duke University',
  'Dulaney High School',
  'Duquesne University',
  'Durant High School',
  'Durham College',
  'Durham University',
  'Dwarkadas J. Sanghvi College of Engineering',
  'Dwight-Englewood School',
  'Earl of March Secondary School',
  'Earlham College',
  'East Brunswick High School',
  'East Central University',
  'East Chapel Hill High Schoo',
  'East Los Angeles College',
  'EASTERN Center for Arts and Technology',
  'Eastern High School - Louisville',
  'Eastern Michigan University',
  'Eastern Regional High School',
  'Eastern University - St. Davids',
  'Eastern University Academy Charter School',
  'Eastern Washington University',
  'Eckerd College',
  'École Centrale Paris',
  'École de technologie supérieure',
  'École nationale supérieure d’électronique, informatique, télécommunications, mathématique et mécanique de Bordeaux (ENSEIRB-MATMECA)',
  'École Polytechnique de Montréal',
  'Edina High School',
  'Edinburgh Napier University',
  'Edison High School',
  'Edward R. Murrow High School',
  'Eidgenössische Technische Hochschule (ETH) Zürich',
  'El Camino College',
  'El Centro College',
  'El Centro de Estudiantes',
  'Elgin Academy',
  'Elizabeth High School',
  'Elon University',
  'Embry-Riddle Aeronautical University',
  'Emory University',
  'EPFL | École polytechnique fédérale de Lausanne',
  'EPITECH Bordeaux',
  'Erasmus Hogeschool Brussel',
  'Erie Community College',
  'Ernest Manning High School',
  'Esperanza Academy Charter School',
  'Esperanza Cyber Charter School',
  'Evergreen Valley College',
  'Evergreen Valley High School',
  'Fachhochschule Dortmund',
  'Fahaheel Al-Watanieh Indian Private School',
  'Fairfield University',
  'Fairleigh Dickinson University',
  'Fairview High School',
  'Farmingdale State College',
  'FernUniversität in Hagen',
  'First Philadelphia Preparatory Charter School',
  'Fitchburg State University',
  'Florida Agricultural & Mechanical (A&M) University',
  'Florida Atlantic University',
  'Florida Gulf Coast University',
  'Florida Institute Of Technology',
  'Florida International University',
  'Florida Polytechnic University',
  'Florida State University',
  'Fontys Hogeschool',
  'Foothill College',
  'Fordham University',
  'Forest Heights Collegiate Institute',
  'Forest Park High School - Baltimore',
  'Forest Park High School - Forest Park, GA',
  'Forest Park High School - Woodbridge',
  'Fort Scott Community College',
  'Fr. Conceicao Rodrigues College of Engineering',
  'Francis Holland School',
  'Francis Lewis High School',
  'Frankford High School - Philadelphia',
  'Franklin High School',
  'Franklin Learning Center - Philadelphia',
  'Franklin Towne Charter High School',
  'Franklin W. Olin College of Engineering',
  'Frederick Community College',
  'Freedom High School - Bethlehem',
  'Freedom High School - Woodbridge',
  'Freehold High School',
  'Freire Charter High School',
  'Fremont High School',
  'Full Sail University',
  'Fullerton College',
  'Gandhi Institute of Technology and Management, Bengaluru',
  'Gandhi Institute of Technology and Management, Hyderabad',
  'Gandhi Institute of Technology and Management, Visakhapatnam',
  'Ganga International School',
  'Ganpat University',
  'Gar-Field Senior High School',
  'Garnet Valley High School',
  'George C. Marshall High School',
  "George Heriot's School",
  'George Mason University',
  'George Washington High School - Philadelphia',
  'Georgetown University',
  'Georgia Institute of Technology',
  'Georgia State University',
  'Germantown Friends School',
  'Geroge Washington Carver High School - Philadelphia',
  'Ghent University',
  'GIDC Degree Engineering College',
  'Glassboro High School',
  'Glenaeon Rudolf Steiner School',
  'Glenbrook North High School',
  'Glenbrook South High School',
  'Glendale Community College',
  'Glenforest Secondary School',
  'Goldsmiths, University of London',
  'Gordon Graydon Memorial Secondary School',
  'Gottfried Wilhelm Leibniz Universität Hannover',
  'Government Model Engineering College, Thrikkakara',
  "Governor's School for Science & Technology",
  'Grady High School',
  'Grand Rapids Community College',
  'Grand Valley State University',
  'Greater Lowell Technical High School',
  'Green River College',
  'Greenwood College School',
  'Grinnell College',
  'Guelph Collegiate Vocational Institute',
  'Gujarat Technological University',
  'Gujarat University',
  'Guru Gobind Singh Indraprastha University',
  'Guttman Community College, CUNY',
  'Gwynedd Mercy University',
  'H.N. Werkman College',
  'Haaga-Helia University of Applied Sciences',
  'Hamilton College',
  'Hampshire College',
  'Hampton University',
  'HAN University of Applied Sciences',
  'Hanze University of Applied Sciences',
  'Harcum College',
  'Harper College',
  'Harrisburg University - Harrisburg Campus',
  'Harrisburg University - Philadelphia Campus',
  'Harrison Career Institute',
  'Harvard Medical School',
  'Harvard University',
  'Harvey Mudd University',
  'Hasso-Plattner-Institut Academy',
  'Haverford College',
  'Hazleton Area High School',
  'Head-Royce School',
  'Health Careers High School',
  'Heartland Community College',
  'Helwan University',
  'Henry M. Gunn High School',
  'Herguan University',
  'Heritage Institute of Technology',
  'Het Baarnsch Lyceum',
  'High Technology High School',
  'Highland Park High School',
  'Hillsborough Community College',
  'Hillsborough High School',
  'Hinsdale Central High School',
  'Hiram College',
  'Hofstra University',
  'Hogeschool Thomas More',
  'Hogeschool van Amsterdam',
  'Holton-Arms School',
  'Holy Family University',
  'Homestead High School',
  'Hong Kong University of Science and Technology',
  'Hood College',
  'Horace Furness High School',
  'Horace Mann School',
  'Hostos Community College, CUNY',
  'Houghton High School',
  'Houston Community College',
  'Howard University',
  'Hudson County Community College',
  'Hudson Valley Community College',
  'Hunter College High School',
  'Hunter College, CUNY',
  'Huron Heights Secondary School',
  'Hussian School of Art',
  'I.T.S Engineering College',
  'Iliria College',
  'Illinois Institute of Technology',
  'Illinois State University',
  'Imhotep Institute Charter High School',
  'Immaculata University',
  'Imperial College London',
  'Indian Hills Community College',
  'Indian Institute of Engineering Science and Technology Shibpur',
  'Indian Institute of Information Technology Allahabad',
  'Indian Institute of Technology Bhubaneswar',
  'Indian Institute of Technology Bombay',
  'Indian Institute of Technology Gandhinagar',
  'Indian Institute of Technology Guwahati',
  'Indian Institute of Technology Gwalior',
  'Indian Institute of Technology Hyderabad',
  'Indian Institute of Technology Jabalpur',
  'Indian Institute of Technology Jodhpur',
  'Indian Institute of Technology Kanpur',
  'Indian Institute of Technology Kharagpur',
  'Indian Institute of Technology Kota',
  'Indian Institute of Technology Madras',
  'Indian Institute of Technology Roorkee',
  'Indian Institute of Technology Ropar',
  'Indian School of Mines, Dhanbad',
  'Indiana State University',
  'Indiana University',
  'Indiana University of Pennsylvania',
  'Indiana University-Purdue University Fort Wayne',
  'Indiana UniversityPurdue University Indianapolis',
  'Indira Gandhi Delhi Technical University for Women',
  'Indira Gandhi National Open University',
  'Indraprastha Institute of Information Technology',
  'Insight PA Cyber Charter School',
  'Institut polytechnique de Bordeaux (INP)',
  'Institute of Engineering and Rural Technology Allahabad',
  'Institute of Technical Education and Research (ITER), Bhubaneswar',
  'Instituto Politécnico Nacional',
  'Instituto Tecnológico Autónomo de México (ITAM)',
  'Instituto Tecnólogico de La Laguna (ITL)',
  'Instituto Tecnológico Superior de Cintalapa',
  'Instituto Tecnológico Superior de El Mante',
  'Instituto Tecnológico Superior de los Ríos',
  'Instituto Tecnologico Superior de San Martin Texmelucan',
  'Instituto Tecnológico y de Estudios Superiores de Monterrey (ITESM)',
  'Instituto Tecnológico y de Estudios Superiores de Monterrey (ITESM) Campus Aguascalientes',
  'Instituto Tecnológico y de Estudios Superiores de Monterrey (ITESM) Campus Chiapas',
  'Instituto Tecnológico y de Estudios Superiores de Monterrey (ITESM) Campus Chihuahua',
  'Instituto Tecnológico y de Estudios Superiores de Monterrey (ITESM) Campus Ciudad de Mexico',
  'Instituto Tecnológico y de Estudios Superiores de Monterrey (ITESM) Campus Ciudad Juárez',
  'Instituto Tecnológico y de Estudios Superiores de Monterrey (ITESM) Campus Cuernavaca',
  'Instituto Tecnológico y de Estudios Superiores de Monterrey (ITESM) Campus Cumbres',
  'Instituto Tecnológico y de Estudios Superiores de Monterrey (ITESM) Campus Eugenio Garza Lagüera',
  'Instituto Tecnológico y de Estudios Superiores de Monterrey (ITESM) Campus Eugenio Garza Sada',
  'Instituto Tecnológico y de Estudios Superiores de Monterrey (ITESM) Campus Guadalajara',
  'Instituto Tecnológico y de Estudios Superiores de Monterrey (ITESM) Campus Hidalgo',
  'Instituto Tecnológico y de Estudios Superiores de Monterrey (ITESM) Campus Irapuato',
  'Instituto Tecnológico y de Estudios Superiores de Monterrey (ITESM) Campus Laguna',
  'Instituto Tecnológico y de Estudios Superiores de Monterrey (ITESM) Campus León',
  'Instituto Tecnológico y de Estudios Superiores de Monterrey (ITESM) Campus Morelia',
  'Instituto Tecnológico y de Estudios Superiores de Monterrey (ITESM) Campus Obregón',
  'Instituto Tecnológico y de Estudios Superiores de Monterrey (ITESM) Campus Puebla',
  'Instituto Tecnológico y de Estudios Superiores de Monterrey (ITESM) Campus Querétaro',
  'Instituto Tecnológico y de Estudios Superiores de Monterrey (ITESM) Campus Saltillo',
  'Instituto Tecnológico y de Estudios Superiores de Monterrey (ITESM) Campus San Luis Potosí',
  'Instituto Tecnológico y de Estudios Superiores de Monterrey (ITESM) Campus Santa Catarina',
  'Instituto Tecnológico y de Estudios Superiores de Monterrey (ITESM) Campus Santa Fe',
  'Instituto Tecnológico y de Estudios Superiores de Monterrey (ITESM) Campus Sinaloa',
  'Instituto Tecnológico y de Estudios Superiores de Monterrey (ITESM) Campus Sonora',
  'Instituto Tecnológico y de Estudios Superiores de Monterrey (ITESM) Campus Tampico',
  'Instituto Tecnológico y de Estudios Superiores de Monterrey (ITESM) Campus Toluca',
  'Instituto Tecnológico y de Estudios Superiores de Monterrey (ITESM) Campus Valle Alto',
  'Instituto Tecnológico y de Estudios Superiores de Monterrey (ITESM) Campus Veracruz',
  'Instituto Tecnológico y de Estudios Superiores de Monterrey (ITESM) Campus Zacatecas',
  'Instituto Tecnológico y de Estudios Superiores de Occidente (ITESO)',
  'Instytut Pamięci Narodowej',
  'International Institute of Information Technology-Hyderabad',
  'International Institute Of Information Technology-Naya Raipur',
  'International Leadership Charter High School',
  'International School of Choueifat',
  'Iowa Central Community College',
  'Iowa State University',
  'Iowa Western Community College',
  'Istanbul University',
  'IT University of Copenhagen',
  'Ithaca College',
  'ITMO University',
  'Jacobs University Bremen',
  'Jagiellonian University',
  'Jaipur National University',
  'Jalpaiguri Government Engineering College',
  "James Gillespie's High School",
  'James Madison High School',
  'James Madison University',
  'Jaypee Institute Of Information Technology',
  'John A. Ferguson Senior High School',
  'John Abbott College',
  'John Bartram High School',
  'John F. Kennedy Memorial High School',
  'John Jay College of Criminal Justice, CUNY',
  'John Leggott College',
  'John P. Stevens High School',
  'Johns Hopkins University',
  'Johnson & Wales University',
  'Johnson C. Smith University',
  'Jules E. Mastbaum Technical High School',
  'Julia R. Masterman School',
  'K.S. School of Business Management',
  'Kansai University',
  'Kansas State University',
  'Kantipur Engineering College',
  'Karlsruhe Institute of Technology',
  'Karunya Institute of Technology and Sciences',
  'Kathmandu BernHardt College',
  'Kaunas University of Technology',
  'Kean University',
  'Keele University',
  'Kennesaw State University',
  'Kennett High School',
  'Kensington High School Complex',
  'Kent State University',
  'Kent State University at Stark',
  'King Edward VI Five Ways School',
  "King's College London",
  'Kingsborough Community College, CUNY',
  'KIPP DuBois Charter School',
  'Kitchener-Waterloo Collegiate & Vocational School',
  'Knox College',
  'Kraków University of Economics',
  'KTH Royal Institute of Technology',
  'L D College Of Engineering Library',
  'La Roche College',
  'La Salle University - Philadelphia',
  'La Sierra University',
  'Lafayette College',
  'LaGuardia Community College, CUNY',
  'Lake Braddock Secondary School',
  'Lakeside High School',
  'Lampeter-Strasburg High School',
  'Lancaster University',
  'Lankenau High School',
  'Laval University',
  'Lawrence Technological University',
  'Lawrence University',
  'Lehigh University',
  'Lehman College, CUNY',
  'Leiden University',
  'Lewis & Clark College',
  'Lewis University',
  'Lexington High School',
  'Lick Wilmerding High School',
  'LIM College',
  'Lincoln Christian University',
  'Lincoln Technical Institute - Center City Philadelphia',
  'Lincoln Technical Institute - Northeast Philadelphia',
  'Lincoln University',
  'Lindenwood University',
  'Linn-Mar High School',
  'Lisgar Collegiate Institute',
  'Little Flowers Public Sr Secondary School',
  'Livingston High School',
  'Loch Raven High School',
  'Lodz University of Technology',
  'London Metropolitan University',
  'London School of Economics and Political Science',
  'Lone Star College System',
  'Lord Krishna College of Engineering',
  'Los Altos High School',
  'Loughborough University',
  'Louisiana State University',
  'Lowell High School',
  'Loyola Marymount University',
  'Luleå University of Technology, LTU',
  'Luther College',
  'Lynbrook High School',
  'M.V.Jayaraman College of Engineering',
  'Macalester College',
  'MacArthur High School',
  'Macaulay Honors College, CUNY',
  'Macomb Community College',
  'Madan Mohan Malaviya University of Technology',
  'Madison College',
  'Madison West High School',
  "Maggie L. Walker Governor's School",
  'Maharaja Agrasen Institute of Technology',
  'Maharaja Surajmal Institute of Technology',
  'Maine South High School',
  'Malvern Preparatory School',
  'Malaviya National Institute of Technology',
  'Manalapan High School',
  'Manchester Metropolitan University',
  'Manhattan College',
  'Manhattan High School',
  'Manipal Institute of Technology',
  'Manor College',
  'Marc Garneau Collegiate Institute',
  'Marcellus High School',
  'Mariana Bracetti Academy Charter School',
  'Marianopolis College',
  'Marist College',
  'Maritime Academy Charter School (MACHS)',
  'Markham District High School',
  'Markville Secondary School',
  'Marlboro High School',
  'Marquette University',
  'Marshall High School',
  'Martin Luther King High School',
  'Marymount University',
  'Masaryk University',
  'Massachusetts Institute of Technology',
  'Mastery Charter School - Hardy Williams Academy',
  'Mastery Charter School - Thomas Campus',
  'Mastery Charter School at Lenfest Campus',
  'Mastery Charter School at Pickett Campus',
  'Mastery Charter School at Shoemaker Campus',
  'Mater Academy High School',
  'Math, Civics and Sciences Charter School - Philadelphia',
  'Mathematics, Science, and Technology Community Charter School (MaST)',
  'Maulana Abul Kalam Azad University of Technology',
  'Maulana Azad National Institute of Technology',
  'Maulana Azad National Institute of Technology Bhopal',
  'Maumee Valley Country Day School',
  'MBM Engineering College, Jodhpur',
  'McGill University',
  'McMaster University',
  'Medgar Evers College, CUNY',
  'Medical University of Silesia',
  'Menlo School',
  'Merced College',
  'Mercer County Community College',
  'Mercer University',
  'Meredith College',
  'Messiah College',
  'Metas Adventist School',
  'Metropolia University of Applied Sciences',
  'Metropolitan State University',
  'Metuchen High School',
  'Miami Dade College',
  'Miami Lakes Educational Center',
  'Miami University',
  'Michigan State University',
  'Michigan Technological University',
  'Microsoft School of the Future High School',
  'Middle Tennessee State University',
  'Middlebury College',
  'Middlesex County Academy for Science, Mathematics & Engineering Technologies',
  'Middlesex County College',
  'Middlesex University',
  'Middleton High School',
  'Middletown High School South',
  'Midwood',
  'Miles College',
  'Millburn High School',
  'Millburn Middle School',
  'Millville Senior High School',
  'Milwaukee School of Engineering',
  'Mission College Boulevard',
  'Mission San Jose High School',
  'Mississippi State University',
  'Mississippi University for Women',
  'Missouri State University',
  'Missouri University of Science and Technology',
  'Mohammed V University',
  'Molloy College',
  'Monmouth College',
  'Monmouth University',
  'Monroe Community College',
  'Monta Vista High School',
  'Montana State University',
  'Montclair State University',
  'Montgomery Blair High School',
  'Montgomery College',
  'Montgomery County Community College - Central Campus (Blue Bell)',
  'Montgomery County Community College - West Campus (Pottstown)',
  'Montgomery High School',
  'Montville Township High School',
  'Moore College of Art and Design',
  'Moore Middle School',
  'Moorestown High School',
  'Moraine Valley Community College',
  'Morehouse College',
  'Morgan State University',
  'Morris County School of Technology',
  'Morton College',
  'Moscow Institute of Physics and Technology',
  'Moscrop Secondary School',
  'Motilal Nehru National Institute of Technology',
  'Motilal Nehru National Institute of Technology Allahabad',
  'Motivation High School (formerly John Bartram High School)',
  'Mount Holyoke College',
  'Mountain View High School',
  'Mt. San Antonio College',
  'Muhlenberg college',
  'Multi-Cultural Academy Charter School',
  'Murrell Dobbins Technical High School',
  'Nanyang Technological University',
  'Narsee Monjee College of Commerce and Economics',
  'Nashua High School South',
  'National Institute of Engineering, Mysore',
  'National Institute of Technology Calicut',
  'National Institute of Technology, Jamshedpur',
  'National Institute of Technology, Raipur',
  'National Institute of Technology, Silchar',
  'National Institute of Technology, Srinagar',
  'National Institute of Technology, Tiruchirappalli',
  'National Institute of Technology, Warangal',
  'National Research University Higher School Of Economics',
  'National Univeristy of Singapore',
  'Netaji Subhas Institute Of Technology',
  'Netaji Subhash Engineering College',
  'Neumann University',
  'New Albany High School',
  'New Foundations Charter School - Philadelphia',
  'New Jersey City University',
  'New Jersey Institute of Technology',
  'New Providence High School',
  'New River Community College',
  'New York City College of Technology, CUNY',
  'New York Institute of Technology',
  'New York University',
  'New York University Abu Dhabi',
  'Newcastle University',
  'Newton South High School',
  'Niagara College',
  'Nipissing University',
  'Nirma University',
  'Noakhali Science and Technology University',
  'Norco College',
  'North American University',
  'North Andover High School',
  'North Brunswick Township High School',
  'North Carolina Agricultural and Technical (A&T) State University',
  'North Carolina School of Science and Mathematics',
  'North Carolina State University',
  'North Dakota State University',
  'North Hunterdon High School',
  'North Park Secondary School',
  'North Penn High School',
  'North Shore Community College',
  'Northeast High School - Philadelphia',
  'Northeastern University',
  'Northern Arizona University',
  'Northern Illinois University',
  'Northern Kentucky University',
  'Northern Michigan University',
  'Northern Secondary School',
  'Northern Virginia Community College',
  'Northumbria University',
  'Northview High School',
  'Northwest Missouri State University',
  'Northwest Parkway High School',
  'Northwest Vista College',
  'Northwestern Oklahoma State University',
  'Northwestern University',
  'Northwood Academy/Arts School',
  'Nottingham Trent University',
  'Novi High School',
  'Oakland Community College',
  'Oakland University',
  'Oberlin College',
  'Ocean City High School',
  'Ocean County College',
  'Oglethorpe University',
  'Ohio Christian University',
  'Ohio University',
  'Okemos High School',
  'Oklahoma State University',
  'Old Dominion University',
  'Old Westbury, SUNY',
  'Olney High School',
  'Onondaga Community College',
  'Opolska University of Technology',
  'Oregon State University',
  'Orleans Technical Institute',
  'Osbourn Park High School',
  'Ostbayerische Technische Hochschule Regensburg',
  'Otterbein University',
  'Overbrook High School - Philadelphia',
  'Oxford Academy High School',
  'Oxford Brookes University',
  'Pace University',
  'Palo Alto High School',
  'Palomar College',
  'Pandit Deendayal Petroleum University',
  'Paramount International School',
  'Parkview High School',
  'Parkway Center City High School',
  'Parkway West High School',
  'Parsippany High School',
  'Parsons School of Design',
  'Parul Institute of Engineering & Technology',
  'Pasadena City College',
  'Pascal English School, Cyprus',
  'Pathways School Noida',
  'Patriot High School - Nokesville',
  'Patriot High School - Riverside',
  'Paul Robeson High School (formerly John Bartram High School)',
  'Peirce College',
  'Penn State Erie, The Behrend College',
  'Penncrest High School',
  'Pennsylvania Academy of the Fine Arts',
  'Pennsylvania Cyber Charter School',
  'Pennsylvania Distance Learning Charter School - Online',
  'Pennsylvania Institute of Technology - Center City Philadelphia',
  'Pennsylvania Institute of Technology - Media',
  'Pennsylvania Leadership Charter School - Online',
  'Pennsylvania Virtual Charter School',
  'PES University',
  'Philadelphia Academy Charter School',
  'Philadelphia Electrical and Technology Charter School',
  'Philadelphia High School for Girls',
  'Philadelphia Performing Arts Charter School (String Theory High School) - Vine Street Campus',
  'Piedmont High School',
  'Pierre Elliott Trudeau High School',
  'Pima Community College',
  'Pingree School',
  'Piscataway Township High School',
  'Pittsburgh Technical College - Philadelphia',
  'Pittsburgh Technical Institute',
  'Plano East Senior High School',
  'Plovdiv Medical University',
  'Pokhara University',
  'Politecnico di Milano',
  'Polsko-Japońska Akademia Technik Komputerowych',
  'Pomona College',
  'Poolesville High School',
  'Poornima College of Engineering',
  'Poornima Group of Institutions',
  'Poornima Institute of Engineering and Technology',
  'Pope John Paul II High School',
  'Port Credit Secondary School',
  'Porter-Gaud School',
  'Portland State University',
  'Potomac Senior High School',
  'Potsdam, SUNY',
  'Poznań University of Technology',
  'Presidency School, Surat.',
  'Preston High School',
  'Preston University',
  'Princeton High School',
  'Princeton University',
  'Purdue University',
  'Queen Mary University of London',
  "Queen's University",
  'Queens College, CUNY',
  'Queensborough Community College, CUNY',
  'R.V. College Of Engineering',
  'Radnor High School',
  'Raksha Shakti University',
  'Ramapo College of New Jersey',
  'Ramapo High School',
  'Rani Laxmi Bai Public School',
  'Raritan Valley Community College',
  'Ravenscroft School',
  'Ravenwood High School',
  'Reach Cyber Charter School',
  'Red Bank Regional High School',
  'Reed College',
  'Regis High School',
  'Rensselaer Polytechnic Institute',
  'Rheinisch-Westfälische Technische Hochschule Aachen (RWTH)',
  'Rhode Island College',
  'Rhode Island School of Design',
  'Rhodes College',
  'Rice University',
  'Richard Montgomery High School',
  'Richard Stockton University',
  'Richardson High School',
  'Richland College',
  'Richmond Hill High School',
  'Rider University',
  'Ridgewood High School',
  'Riga Technical University',
  'River Dell High School',
  'Robert Gordon University',
  'Rochester Institute of Technology',
  'Rock Ridge High School',
  'Roger Williams University',
  'Rollins College',
  'Roosevelt High School',
  'Rosa Parks Middle School',
  'Rose-Hulman Institute of Technology',
  'Rosemont College',
  'Rowan College at Burlington County - Mount Holly',
  'Rowan College at Burlington County - Pemberton',
  'Rowan College at Burlington County - Willingboro',
  'Rowan College at Gloucester County - Mount Laurel',
  'Rowan University',
  'Roxborough High School',
  'Roxbury High School',
  'Royal Holloway, University of London',
  'Rudbecksgymnasiet',
  'Rutgers University - Newark',
  'Rutgers University  Camden',
  'Rutgers, The State University of New Jersey',
  'Ryde School',
  'Ryerson University',
  'Saginaw Valley State University',
  'Sahrdaya College of Engineering and Technology',
  'Saint Joseph High School',
  "Saint Joseph's College of Maine",
  "Saint Joseph's Preparatory School - Philadelphia",
  "Saint Joseph's University - Philadelphia",
  'Saint Paul College',
  "Saint Peter's Preparatory School",
  "Saint Peter's University",
  'Salem Community College',
  'Salem State University',
  'Samuel Fels High School - Philadelphia',
  'San Diego State University',
  'San Francisco State University',
  'San Jose State University',
  'San Marcos High School',
  'San Marin High School',
  'San Mateo High School',
  'Sankofa Freedom Academy Charter School',
  'Sant Longowal Institute of Engineering and Technology',
  'Santa Barbara City College',
  'Santa Clara University',
  'Santa Margarita Catholic High School',
  'Santa Rosa Junior College',
  'Saratoga High School',
  'Sardar Patel University',
  'Sardar Vallabhbhai National Institute of Technology, Surat',
  'Sarvajanik College of Engineering & Technology',
  'Saurashtra University Rajkot',
  'Savannah State University',
  'Savitribai Phule Pune University',
  'School of Professional Studies, CUNY',
  'School of Visual Arts, New York',
  'Science Leadership Academy',
  'Scranton High School',
  'Seneca College',
  'Seton Hall University',
  'Seven Lakes High School',
  'Seventh Day Adventist High School',
  'Shaker High School',
  'Shankersinh Vaghela Bapu Institute of Technology',
  'Sheffield Hallam University',
  'Shelton High School',
  'Sherwood Convent School',
  'Sherwood High School',
  'Shiv Nadar University',
  'Shri Govindram Seksaria Institute of Technology and Science',
  'Shri Guru Ram Rai Public School',
  'Shri Vaishnav Institute of Technology and Science',
  'Siena College',
  'Silesian University of Technology',
  'Silver Oak College of Engineering & Technology',
  'Simmons College',
  'Simón Bolívar University',
  'Simon Fraser University',
  'Simon Gratz High School',
  'Simpson College',
  'Sinclair Community College',
  'Singapore University of Technology and Design',
  'Sir John A. Macdonald Secondary School',
  'Sir Padampat Singhania University',
  'Sitarambhai Naranji Patel Institute of Technology & Research Centre',
  'Skidmore College',
  'Slippery Rock University of Pennsylvania',
  'Slovak University of Technology in Bratislava (STU)',
  'Smith College',
  'Spelman College',
  'SOAS University of London',
  'Souderton Area High School',
  'South Brunswick High School',
  'South Carolina State University',
  'South Dakota School of Mines and Technology',
  'South Hills School of Business & Technology',
  'South Lakes High School',
  'South Philadelphia High School',
  'South Texas College',
  'Southeastern Louisiana University',
  'Southern Connecticut State University',
  'Southern Illinois University Carbondale',
  'Southern Illinois University Edwardsville',
  'Southern Methodist University',
  'Southern Oregon University',
  'Southern University and A&M College',
  'Southern Utah University',
  'Southwestern College',
  'Spotswood High School',
  'Spring Arbor University',
  'Springside Chestnut Hill Academy',
  'Sreenidhi Institute of Science & Technology',
  'Sri Sivasubramaniya Nadar College of Engineering',
  'St Brendan High School',
  'St Edwards University',
  "St Mary's Catholic High School  Croydon",
  "St Mary's CE High School  Cheshunt",
  "St Paul's Catholic College  Sunbury-on-Thames",
  'St. Charles Borromeo Seminary',
  'St. Cloud State University',
  'St. David Catholic Secondary School',
  "St. John's University, New York",
  "St. Mark's School, Hong Kong",
  "St. Mary's Convent School",
  "St. Mary's Ryken High School",
  'St. Michael College of Engineering & Technology',
  'St. Raymond High School for Boys And Girls',
  'St. Theresa of Lisieux Catholic High School',
  "St. Xavier's Senior Secondary School, Jaipur",
  'Stanford University',
  'Star Technical Institute',
  'Staten Island Technical High School',
  'Stephen F. Austin State University',
  'Stetson University',
  'Stevens Institute of Technology',
  'Stevenson University',
  'Stockholm University',
  'Stockton University',
  'Stonehill College',
  'Stonewall Jackson High School - Manassas',
  'Stonewall Jackson High School - Quicksburg',
  'Stony Brook University, SUNY',
  'Strawberry Mansion High School',
  'Strayer University - Bensalem',
  'Strayer University - Philadelphia Center City',
  'Stuyvesant High School',
  'Sulphur High School',
  'SUNY Polytechnic Institute',
  'SUPINFO International University',
  'Susq-Cyber Charter School',
  'Susquehanna University',
  'Sussex County Community College',
  'Swansea University',
  'Swarthmore College',
  'Symbiosis International University',
  'Syracuse University',
  'Tacoma Community College',
  'Tacony Academy Charter School',
  'Tadeusz Kościuszko University of Technology',
  'Tallinn University',
  'Tallinn University of Technology',
  'Talmudical Yeshiva of Philadelphia',
  'Tampere University of Applied Sciences',
  'Tampere University of Technology',
  'Tarleton State University',
  'TECH Freire Charter High School',
  'Technische Universität München',
  'Techno India College of Technology',
  'Techno India University',
  'Tecnológico de Estudio Superiores de Ixtapaluca',
  'Tecnológico de Estudios Superiores de Ecatepec',
  'Tecnológico de Estudios Superiores de Jilotepec',
  'Teesside University',
  'Temple University',
  'Temple University - Ambler',
  'Temple University - Harrisburg',
  'Temple University - Health Sciences Campus',
  'Temple University - Rome',
  'Temple University - Tokyo',
  'Tenafly High School',
  'Tennessee State University',
  'Texas A&M University',
  'Texas A&M University  Central Texas',
  'Texas A&M University  Corpus Christi',
  'Texas A&M University  Kingsville',
  'Texas Christian University',
  'Texas Southern University',
  'Texas Southmost College',
  'Texas State University',
  'Texas Tech University',
  'Thakur College of Engineering and Technology',
  'The Arts Academy at Benjamin Rush',
  'The British University In Egypt',
  'The Bronx High School of Science',
  'The City College of New York, CUNY',
  'The College at Brockport, SUNY',
  'The College of New Jersey',
  'The College of Saint Rose',
  'The Curtis Institute of Music',
  'The George Washington University',
  "The Governor's School @ Innovation Park",
  'The Harker School',
  'The Hill School',
  'The Katholieke Universiteit Leuven',
  'The LNM Institute of Information Technology',
  'The Maharaja Sayajirao University of Baroda',
  'The Mount Tabor Training College',
  'The Ohio State University',
  'The Open University',
  'The Pennsylvania State University',
  'The Pennsylvania State University  Abington Campus',
  'The Pennsylvania State University  Berks',
  'The Pennsylvania State University  Brandywine',
  'The Pennsylvania State University  Harrisburg',
  'The Pennsylvania State University  York Campus',
  'The Roxbury Latin School',
  'The Savannah College of Art and Design',
  'The SRM University',
  'The Technical University of Denmark',
  'The Technische Universität Berlin',
  'The Université de Sherbrooke',
  'The University of Aberdeen',
  'The University of Akron',
  'The University of Alabama',
  'The University of Alabama at Birmingham',
  'The University of Alberta',
  'The University of Applied Sciences Upper Austria',
  'The University of Arizona',
  'The University of Arkansas',
  'The University of Bath',
  'The University of Bedfordshire',
  'The University of Birmingham',
  'The University of Bolton',
  'The University of Bonn',
  'The University of Bristol',
  'The University of British Columbia',
  'The University of Calgary',
  'The University of Calicut',
  'The University of California, Berkeley',
  'The University of California, Davis',
  'The University of California, Irvine',
  'The University of California, Los Angeles',
  'The University of California, Merced',
  'The University of California, Riverside',
  'The University of California, San Diego',
  'The University of California, Santa Barbara',
  'The University of California, Santa Cruz',
  'The University of Cambridge',
  'The University of Central Florida',
  'The University of Chicago',
  'The University of Colorado Boulder',
  'The University of Colorado Colorado Springs',
  'The University of Connecticut',
  'The University of Dallas',
  'The University of Delaware',
  'The University of Denver',
  'The University of Derby',
  'The University of Dundee',
  'The University of Edinburgh',
  'The University of Essex',
  'The University of Evansville',
  'The University of Exeter',
  'The University of Falmouth',
  'The University of Florida',
  'The University of Gdańsk',
  'The University of Georgia',
  'The University of Glasgow',
  'The University of Groningen',
  'The University of Guelph',
  'The University of Houston',
  'The University of Houston  Clear Lake',
  'The University of Houston  Downtown',
  'The University of Huddersfield',
  'The University of Idaho',
  'The University of Illinois at Chicago',
  'The University of Illinois at Urbana-Champaign',
  'The University of Information Technology and Management in Rzeszow',
  'The University of Iowa',
  'The University of Kansas',
  'The University of Kent',
  'The University of Kentucky',
  'The University of La Verne',
  'The University of Leeds',
  'The University of Leicester',
  'The University of Lincoln',
  'The University of Liverpool',
  'The University of Ljubljana',
  'The University of Louisiana at Lafayette',
  'The University of Louisiana at Monroe',
  'The University of Louisville',
  'The University of Málaga',
  'The University of Manchester',
  'The University of Manitoba',
  'The University of Maryland, Baltimore County',
  'The University of Maryland, College Park',
  'The University of Massachusetts Amherst',
  'The University of Massachusetts Boston',
  'The University of Massachusetts Dartmouth',
  'The University of Massachusetts Lowell',
  'The University of Miami',
  'The University of Michigan',
  'The University of Michigan-Dearborn',
  'The University of Michigan-Flint',
  'The University of Minnesota',
  'The University of Mississippi',
  'The University of Missouri',
  'The University of Missouri-Kansas City',
  'The University of Missouri-St. Louis',
  'The University of Nebraska-Lincoln',
  'The University of New Brunswick',
  'The University of New Hampshire',
  'The University of New Haven',
  'The University of North Carolina at Chapel Hill',
  'The University of North Carolina at Charlotte',
  'The University of North Carolina at Greensboro',
  'The University of North Texas',
  'The University of Northampton',
  'The University of Notre Dame',
  'The University of Nottingham',
  'The University of Oklahoma',
  'The University of Ontario Institute of Technology',
  'The University of Oregon',
  'The University of Ottawa',
  'The University of Oulu',
  'The University of Oxford',
  'The University of Pennsylvania',
  'The University of Petroleum and Energy Studies',
  'The University of Phoenix',
  'The University of Pittsburgh',
  'The University of Portland',
  'The University of Portsmouth',
  'The University of Puerto Rico, Mayagüez Campus',
  'The University of Puerto Rico, Río Piedras Campus',
  'The University of Richmond',
  'The University of Rochester',
  'The University of Salford',
  'The University of San Francisco',
  'The University of Sharjah',
  'The University of Sheffield',
  'The University of Silesia in Katowice',
  'The University of South Carolina',
  'The University of South Florida',
  'The University of Southampton',
  'The University of Southern California',
  'The University of Southern Denmark',
  'The University of St Andrews',
  'The University of St. Gallen',
  'The University of St. Thomas',
  'The University of Stirling',
  'The University of Strathclyde',
  'The University of Stuttgart',
  'The University of Surrey',
  'The University of Sussex',
  'The University of Tampa',
  'The University of the District of Columbia',
  'The University of Tennessee',
  'The University of Texas  Pan American',
  'The University of Texas at Arlington',
  'The University of Texas at Austin',
  'The University of Texas at Dallas',
  'The University of Texas at El Paso',
  'The University of Texas at San Antonio',
  'The University of Texas at Tyler',
  'The University of Texas of the Permian Basin',
  'The University of Texas Rio Grande Valley',
  'The University of the Pacific',
  'The University of the South - Sewanee',
  'The University of Toledo',
  'The University of Toronto',
  'The University of Toronto Mississauga',
  'The University of Toronto Scarborough',
  'The University of Tulsa',
  'The University of Utah',
  'The University of Vermont',
  'The University of Victoria',
  'The University of Virginia',
  'The University of Warsaw',
  'The University of Warwick',
  'The University of Washington',
  'The University of Washington Bothell',
  'The University of Waterloo',
  'The University of West Georgia',
  'The University of Western Ontario',
  'The University of Westminster',
  'The University of Windsor',
  'The University of Wisconsin-Eau Claire',
  'The University of Wisconsin-Green Bay',
  'The University of Wisconsin-La Crosse',
  'The University of Wisconsin-Madison',
  'The University of Wisconsin-Milwaukee',
  'The University of Wisconsin-Oshkosh',
  'The University of Wisconsin-Parkside',
  'The University of Wisconsin-Platteville',
  'The University of Wisconsin-River Falls',
  'The University of Wisconsin-Stevens Point',
  'The University of Wisconsin-Stout',
  'The University of Wisconsin-Superior',
  'The University of Wisconsin-Whitewater',
  'The University of Wolverhampton',
  'The University of Wrocław',
  'The University of York',
  'The University of Zagreb',
  'The Workshop School - Philadelphia',
  'Thomas A. Edison High School - Philadelphia',
  'Thomas Edison State College',
  'Thomas Jefferson High School for Science and Technology',
  'Thomas Jefferson University - East Falls (formerly Philadelphia University)',
  'Thomas Jefferson University - Philadelphia Center City',
  'Thomas Nelson Community College',
  'Thomas S. Wootton High School',
  'Thompson Institute - Philadelphia',
  'Tongji University',
  'Towson High School',
  'Towson University',
  'Trent University',
  'Trinity College',
  'Trinity International University',
  'Trinity Valley School',
  'Troy Athens High School',
  'Troy High School',
  'Troy University',
  'Truman State University',
  'Tshwane University of Technology',
  'TU/e Technische Universiteit Eindhoven University of Technology',
  'Tufts University',
  'Tulane University',
  'Tunis El Manar University',
  'Turner Fenton Secondary School',
  'Ulster University',
  'UNAM FES Aragón',
  'Union County College',
  'Union County Magnet High School',
  'Union County Vocational-Technical Schools',
  'Union University',
  'Unionville High School',
  'United College of Engineering and Research',
  'United Institute of Technology',
  'Universidad Autónoma de Baja California (UABC), Tijuana',
  'Universidad Autónoma de Coahuila',
  'Universidad Autónoma de Madrid',
  'Universidad Autónoma de Nuevo León',
  'Universidad Autónoma de San Luis Potosí',
  'Universidad Autónoma de Tlaxcala',
  'Universidad Autónoma del Estado de México',
  'Universidad Autónoma del Estado de Morelos',
  'Universidad Autónoma del Perú',
  'Universidad Autónoma Metropolitana',
  'Universidad Centro de Estudios Cortazar',
  'Universidad de Guadalajara',
  'Universidad de Guanajuato',
  'Universidad de La Salle Bajío',
  'Universidad de La Laguna',
  'Universidad de Monterrey',
  'Universidad del Desarrollo',
  'Universidad del Valle de México',
  'Universidad en Línea, Mexico',
  'Universidad Iberoamericana',
  'Universidad Interamericana de Puerto Rico',
  'Universidad Nacional Autónoma de México',
  'Universidad Panamericana',
  'Universidad Politécnica de Guanajuato',
  'Universidad Politécnica de Querétaro',
  'Universidad TecMilenio',
  'Universidad Tecnológica de México',
  'Universidad Tecnológica de Puebla',
  'Universidad Tecnológica de Torreón',
  'Universidad Veracruzana',
  'Universitat Autònoma de Barcelona, UAB',
  'Universitat de Barcelona',
  'Universitat Oberta de Catalunya, UOC',
  'Universitat Politècnica de Catalunya',
  'Universitat Politècnica de Catalunya, UPC',
  'Universitat Pompeu Fabra',
  'Universität Regensburg',
  'Universität Zürich',
  'Universitatea Politehnica Timişoara',
  'Université de Bordeaux',
  'Université de Mons',
  'Université du Québec à Montréal',
  'University at Albany, SUNY',
  'University at Binghamton, SUNY',
  'University at Buffalo, SUNY',
  'University at New Paltz, SUNY',
  'University at Oneonta, SUNY',
  'University at Orange, SUNY',
  'University at Oswego, SUNY',
  'University at Plattsburgh, SUNY',
  'University Campus Suffolk',
  'University College London',
  'University of Basel',
  'University of Białystok',
  'University of Cincinnati',
  'University of Cincinnati Clermont College',
  'University of Duisburg-Essen',
  'University of Gothenburg',
  'University of Helsinki',
  'University of Hull',
  'University of London',
  'University of Mary Washington',
  'University of Maryland University College',
  'University of North America',
  'University of North Florida',
  'University of North Georgia',
  'University of Pikeville',
  'University of Queensland',
  'University of Roehampton',
  'University of Saskatchewan',
  'University of Science and Technology Houari Boumediene',
  'University of Southampton',
  'University of Southern Indiana',
  'University of Sunderland',
  'University of Tartu',
  'University of the Arts - Philadelphia',
  'University of the People',
  'University of the Sciences in Philadelphia',
  'University of Trento',
  'University of Udaipur',
  'University of Valley Forge',
  'University of Washington Tacoma',
  'University of West Florida',
  'Upper Canada College',
  'Upper Darby High School',
  'Upper Iowa University',
  'Upper Moreland High School',
  'Urbana High School',
  'Ursinus College',
  'Utah State University',
  'Utica College',
  'Utkal University',
  'Uttar Pradesh Technical University',
  'Uttaranchal Institute of Technology',
  'Vadodara Institute of Engineering',
  'Valencia College',
  'Valley Christian High School',
  'Valley High School',
  'Vanderbilt University',
  'Vanier College',
  'Vassar College',
  'Veer Narmad South Gujarat University',
  'Veer Surendra Sai University of Technology, Burla',
  'Vel Tech Multi Tech Dr.Rangarajan Dr.Sakunthala Engineering College',
  'Vellore Institute of Technology',
  'Veterans Memorial Early College High School',
  'VIA University College',
  'Victoria Park Collegiate Institute',
  'Vidyakunj International School',
  'Villanova University',
  'Vincennes University',
  'Vincent Massey Secondary School',
  'Virginia Commonwealth University',
  'Virginia Tech',
  'Virtual High School @ PWCS',
  'Visvesvaraya National Institute of Technology',
  'Visvesvaraya Technological University',
  'VIT University',
  "Vivekanand Education Society's Institute of Technology",
  'Vivekananda College for BCA',
  'Vrije Universiteit Amsterdam',
  'Wake Forest University',
  'Walnut Hill College',
  'Walt Whitman High School',
  'Walter Biddle Saul High School',
  'Ward Melville High School',
  'Warsaw School of Economics',
  'Warsaw University of Technology',
  'Wartburg College',
  'Washington and Lee University',
  'Washington State University',
  'Washington Township High School',
  'Washington University in St. Louis',
  'Waterloo Collegiate Institute',
  'Waunakee High School',
  'Wayne State University',
  'Webb Bridge Middle School',
  'Wellesley College',
  'Wells College',
  'Wentworth Institute of Technology',
  'Wesleyan University',
  'West Chester University',
  'West Morris Mendham High School',
  'West Philadelphia High School',
  'West Potomac High School',
  'West Scranton High School',
  'West Windsor-Plainsboro High School North',
  'West Windsor-Plainsboro High School South',
  'Westdale Secondary School',
  'Western Connecticut State University',
  'Western Governors University',
  'Western Kentucky University',
  'Western Michigan University',
  'Western New England University',
  'Western Technical College',
  'Western University',
  'Western Washington University',
  'Westfield High School',
  'Westminster College',
  'Westminster School',
  'Westwood High School',
  'Whitefish Bay High School',
  'Whitworth University',
  'Wichita State University',
  'Widener University',
  'Wilbert Tucker Woodson High School',
  'Wilfrid Laurier University',
  'Wilkes University',
  'William & Mary',
  'William L. Sayre High School',
  'William Lyon Mackenzie Collegiate Institute',
  'William Paterson University',
  'William W. Bodine High School',
  'Williams College',
  'Williamson Free School of Mechanical Trades',
  'Wilmington University',
  'Wiltshire College',
  'Winona State University',
  'Winston Churchill High School',
  'Winthrop University',
  'Woodbridge High School - Bridgeville',
  'Woodbridge High School - Irvine',
  'Woodbridge High School - London',
  'Woodbridge High School - Woodbridge, NJ',
  'Woodbridge High School - Woodbridge, ON',
  'Woodbridge High School - Woodbridge, VA',
  'Worcester Polytechnic Institute',
  'Worcester State University',
  'World Communications Charter School',
  'Wright State University',
  'Wrocław University of Economics',
  'Wrocław University of Technology',
  'Wyższa Szkoła Biznesu  National-Louis University',
  'Xavier University',
  'Yale University',
  'Yale-NUS College',
  'Yeshiva University',
  'YMCA University of Science & Technology',
  'York College of Pennsylvania',
  'York College, CUNY',
  'York University',
  'Youngstown State University',
  'YouthBuild Philadelphia Charter School',
  'Zespół Szkół im. Jana Pawła II w Niepołomicach',
  'Zespół Szkół Łączności, Monte Cassino 31',
  'Zespół Szkół nr 1 im. Jana Pawła II w Przysusze',
  'Zespół szkół nr 1 im. Stanisława Staszica w Bochni',
  'Zespół Szkół Nr.2 im. Jana Pawła II w Miechowie',
  'Other',
];

export default schoolList;
